/**
 * Logo Slider: Swiper init.
 */
(function () {
	'use strict';

	function initSwiper() {
		if (typeof Swiper === 'undefined') return;
		const el = document.querySelector('.logo__slider');
		if (!el) return;
		new Swiper('.logo__slider', {
			slidesPerView: 'auto',
			spaceBetween: 30,
			speed: 2000,
			autoplay: {
				delay: 10,
				disableOnInteraction: false,
			},
			loop: true,
			allowTouchMove: false,
			resistance: false,
			resistanceRatio: 0,
			breakpoints: {
				320: { slidesPerView: 2, spaceBetween: 10 },
				768: { slidesPerView: 4, spaceBetween: 15 },
			},
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSwiper);
	} else {
		initSwiper();
	}
})();
